import { Typography } from 'antd';

/** 表格中展示 checksum：截断 + 悬停全文 + 一键复制 */
export function ChecksumCell({ value }: { value?: string }) {
  const v = (value || '').trim();
  if (!v) return <Typography.Text type="secondary">-</Typography.Text>;
  const short = v.length > 12 ? `${v.slice(0, 8)}…${v.slice(-4)}` : v;
  return (
    <Typography.Text
      code
      copyable={{ text: v }}
      title={v}
      style={{ fontSize: 12, whiteSpace: 'nowrap' }}
    >
      {short}
    </Typography.Text>
  );
}
